import _ from 'lodash';

const axios = require('axios').default;
const {
    REACT_APP_APPLICATION_ID,
    REACT_APP_ADMIN_GRAPHQL_URL,
} = process.env;

const BASE_URL = REACT_APP_ADMIN_GRAPHQL_URL;

const adminGqlAPI = axios.create({
    baseURL: BASE_URL,
});

const processResponse = (r) => {
    if (r.data && r.data.data) {
        const {
            errors,
            data,
        } = r.data;
        if (errors) {
            let errorMsg = _.reduce(errors, (accum, error, index) => {
                accum = accum + (error.message) ? error.message : '';
                return accum;
            }, "");
            throw new Error(errorMsg);
        } else {
            // console.log(data);
            return data;
        }
    } else {
        throw new Error("Something went wrong with your request. Please try again later.");
    }
};

export const makeGraphQLQuery = async ({query = "", variables = {}, token = ""}) => {
    let output = {r: null, e: null};
    try {
        let r = await adminGqlAPI.post('', {
            query,
            variables,
        }, { headers: { Authorization: token, } });
        output.r = processResponse(r);
        return output;
    } catch (error) {
        output.e = error;
        return output;
    }
};